module.exports = __webpack_public_path__ + "static/img/5.043dfeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/5.png
// module id = 1tkm
// module chunks = 0